// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Mail } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMail(props: any) {
    return <IconBase icon={Mail} {...props} />
  }

  export default IconMail
  